<template>
  <div>
    <PageMain
      :loading="loading"
      :tablePage="page"
      :tableData="tableData"
      @reload="$refs.header.query()"
      ref="tableMain"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <page-header ref="header" slot="header" @query="getData" />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageMain from './table.vue'
import PageHeader from './header'
import EditLoading from '@/mixins/edit-loading'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [EditLoading, BaseTable],
  components: { PageMain, PageHeader },
  props: {
    orderTechPricingSpecCode: { type: String, default: () => '' },
  },
  data() {
    return { usePage: true, loading: false, tableData: [] }
  },
  methods: {
    async getData(form = {}) {
      this.loading = true
      this.$api
        .orderTechPricingGoodsSpecListApi({
          orderTechPricingSpecCode: this.orderTechPricingSpecCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
